import CustomEmpty from 'shared/ui/CustomEmpty'

const emptyClassname = 'w-full h-full flex items-center justify-center'

const NotFoundPage = () => (
  <div className={emptyClassname}>
    <CustomEmpty
      className="max-w-[600px]"
      size="large"
      type="notFound"
      title="Страница не найдена"
      description="Страница, на которую вы пытались перейти, не была найдена."
      btnText="Назад"
    />
  </div>
)

export default NotFoundPage
